import {ExperimentsApi} from '../../common/experiments/ExperimentsApi';
import {SPECS} from '../../editor-script/constants';

export const shouldInstallProductPageOnBlocks = (experimentsApi: ExperimentsApi, isWixStudio: boolean) => {
  if (isWixStudio) {
    return true;
  }
  return experimentsApi.enabled(SPECS.InstallBlocksProductPage);
};
